////////////////////////////////////////////////////////////////////////////////////////////////////////////
// WEBPACK ENTRY POINT: REFERENCES

// this page's HTML template with the [hash] cache-buster
// and the only stylesheet
require('./index.scss');
require('./index.src.html');

// bundle libraries
require('./lib/leaflet-control-zoombar.js');
require('./lib/leaflet-control-zoombar.css');
require('./lib/leaflet-control-credits.js');
require('./lib/leaflet-control-credits.css');



////////////////////////////////////////////////////////////////////////////////////////////////////////////
// BEGIN REAL CODE
// DEFINES

// the default view, starting bounding box, min and max zoom
// the LA region covering the historical maps
// const DEFAULT_BBOX_N =   34.457;
// const DEFAULT_BBOX_S =   33.786;
// const DEFAULT_BBOX_E = -117.771;
// const DEFAULT_BBOX_W = -118.909;
// zoomed in on those 2 parks of itnerest
const DEFAULT_BBOX_N =   34.113;
const DEFAULT_BBOX_S =   34.091;
const DEFAULT_BBOX_E = -118.226;
const DEFAULT_BBOX_W = -118.261;

// we only have tiles for this range, so don't change it unless you're sure
const MIN_ZOOM = 11;
const MAX_ZOOM = 16;

// sidebar width impacts certain other calculations, below. 
// - if this changes in CSS, change it here, too
// - if this changes here, change it in css, too (see div.Sidebar)
const SIDEBARWIDTH = 415;

// what basemaps should exist, and which one is our starting choice?
// see also div.BasemapLayers and initBaseMaps()
// tip: setting the zIndex:1 for these ensures that accidents in layer stacking (or accepting defaults) won't bite you, by keeping these at the bottom
const BASEMAP_DEFAULT = 'light';
const BASEMAPS = [
    {
        id: 'light',
        title: 'Light',
        maplayer: L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
            zindex: 1,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
        }),
    },
    {
        id: 'osm',
        title: 'OpenStreetMap',
        maplayer: L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            zindex: 1,
            attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
        }),
    },
    {
        id: 'sat',
        title: 'Satellite',
        maplayer: L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
            zIndex: 1,
            attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        }),
    },
];

// the overlay layers: a list of sections, each one with a list of layers
// see also div.SidebarLayers which will form the legend, and initMapLegend() which generates the legend and its event handlers
const MAP_LAYERS = [
    {
        title: 'Historical Maps',
        layers: [
            {
                id: 'losangeles_1897',
                title: "1897",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/losangeles_1897/{z}/{x}/{y}.png', {
                    zIndex: 5,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'losangeles_1900',
                title: "1900",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/losangeles_1900/{z}/{x}/{y}.png', {
                    zIndex: 5,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'losangeles_1928',
                title: "1928 - Los Angeles",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/losangeles_1928/{z}/{x}/{y}.png', {
                    zIndex: 40,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'glendale_1928',
                title: "1928 - Glendale",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/glendale_1928/{z}/{x}/{y}.png', {
                    zIndex: 40,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'redlining_1939',
                title: "1939 Redlining",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/redlining_1939/{z}/{x}/{y}.png', {
                    zIndex: 5,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'losangeles_1953',
                title: "1953",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/losangeles_1953/{z}/{x}/{y}.png', {
                    zIndex: 25,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
            {
                id: 'losangeles_1966',
                title: "1966",
                maplayer: L.tileLayer('https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/losangeles_1966/{z}/{x}/{y}.png', {
                    zIndex: 25,
                    tms: true,
                    attribution: ""
                }),
                on: false,
                opacity: 0.8,
            },
        ],
    },
    {
        title: 'Key Parcels',
        layers: [
            {
                id: 'riodelosangeles',
                title: "Rio de Los Angeles State Park",
                maplayer: new L.GeoJSON.AJAX("https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/riodelosangeles.json", {
                    style: {  // for compatibility with L.TileLayer and setOpacity(), set "opacity" on the layer, not this L.GeoJSON layer
                        color: "#afcb73",
                        weight: 2,
                        fillColor: "#afcb73",
                        clickable: false,
                    },
                }),
                on: true,
                opacity: 0.70,
            },
            {
                id: 'riodelosangeles_bowtie',
                title: "Bowtie Parcel",
                maplayer: new L.GeoJSON.AJAX("https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/riodelosangeles_bowtie.json", {
                    style: {  // for compatibility with L.TileLayer and setOpacity(), set "opacity" on the layer, not this L.GeoJSON layer
                        color: "#afcb73",
                        weight: 2,
                        fillColor: "#afcb73",
                        clickable: false,
                    },
                }),
                on: true,
                opacity: 0.70,
            },
            {
                id: 'parcel_g2',
                title: "G2 Parcel (City of LA)",
                maplayer: new L.GeoJSON.AJAX("https://s3-us-west-1.amazonaws.com/ucla-taylor-yards-maptiles/parcelg_g2.json", {
                    style: {  // for compatibility with L.TileLayer and setOpacity(), set "opacity" on the layer, not this L.GeoJSON layer
                        color: "#afcb73",
                        weight: 2,
                        fillColor: "#afcb73",
                        clickable: false,
                    },
                }),
                on: true,
                opacity: 0.70,
            },
        ],
    },
];

////////////////////////////////////////////////////////////////////////////////////////////////////////////
// STARTUP EXECUTION

window.MAP = undefined;


$(document).ready(function () {
    initMap();
    initBaseMaps();
    initMapLegend();

    // show nor hide the sidebar by default
    sidebarToggle(! isMobile() );
});

function initMap() {
    // set up the Leaflet map
    MAP = L.map('Map', {
        zoomControl: false,
        attributionControl: false, // see below
        minZoom:MIN_ZOOM,
        maxZoom:MAX_ZOOM
    });

    // a custom fitBounds() method which checks whether the SIdebar is expanded
    MAP.fitBoundsWithSidebarOffset = function (bounds) {
        var notmobile = ! isMobile();
        var sidebarvisible = $('#Sidebar').offset().left >= 0;

        // we don't use 0 as default padding because we prefer zooming in a bit too closely over being too far out
        // then if the Sidebar is visible, add some left padding so the map is visually centered
        var options = {
            paddingBottomRight: [ 0, 0 ],
            paddingTopLeft: [ 0, 0 ],
        };

        if (notmobile && sidebarvisible) {
            options.paddingTopLeft[0] += SIDEBARWIDTH;
        }
        return this.fitBounds(bounds, options);
    };
    MAP.fitBoundsWithSidebarOffset([[DEFAULT_BBOX_S, DEFAULT_BBOX_W],[DEFAULT_BBOX_N, DEFAULT_BBOX_E]]);

    // afterthought layer:
    // the labels layer at a very high zindex to always show at the top
    /*
    L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_only_labels/{z}/{x}/{y}.png', {
        zIndex: 10000,
    }).addTo(MAP);
    */

    // additional controls
    new L.Control.ZoomBar({
        position: 'topright',
        homeBounds: [ [DEFAULT_BBOX_S,DEFAULT_BBOX_W], [DEFAULT_BBOX_N,DEFAULT_BBOX_E] ]
    }).addTo(MAP);

    new L.controlCredits({
        image: 'images/greeninfo.png',
        link: 'https://www.greeninfo.org/',
        text: 'Interactive mapping<br/>by GreenInfo Network'
    }).addTo(MAP);

    var attribution = L.control.attribution({
        position: 'bottomright',
    }).addTo(MAP);

    L.control.scale({
        position: 'bottomleft',
        updateWhenIdle: true
    }).addTo(MAP);
}

function initBaseMaps() {
    var $legendarea = $('#Sidebar div.BasemapLayers');

    // lay out the UI for the basemap options: radioboxes which call selectBasemap()
    BASEMAPS.forEach((layer) => {
        var html = '';
//gda
        html += '<div class="BasemapEntry" data-layer="${layer.id}">';
        html += `    <label class="control control--radio">`;
        html += `        <input type="radio" name="basemap" value="${layer.id}" onChange="selectBasemap(this.value);" ${layer.id == BASEMAP_DEFAULT ? 'checked' : ''} /> ${layer.title}`;
        html += `        <div class="control__indicator"></div>`;
        html += `    </label>`;
        html += '</div>';
        $(html).appendTo($legendarea);

        // now toggle the layer if it's the chosen one
        if (layer.id == BASEMAP_DEFAULT) {
            selectBasemap(layer.id);
        }
    });
}

function initMapLegend() {
    var $legendarea = $('#Sidebar div.SidebarLayers');

    // within each section
    // compose HTML/DOM element for each legend entry: checkbox, opacity slider, ...
    // old-school tech here but runs swiftly and develops quickly
    MAP_LAYERS.forEach((section) => {
        $(`<h2 class="LayerLegendSectionTitle">${section.title}</h2>`).appendTo($legendarea);

        section.layers.forEach((layer) => {
            let html = '';
            html += `<div class="LayerLegendEntry" data-layer="${layer.id}">`;
            html += `    <label class="control control--checkbox">`;
            html += `        <input type="checkbox" name="maplayers" value="${layer.id}" onChange="toggleLayer(this.value, this.checked);" ${layer.on ? 'checked' : ''} /> ${layer.title}`;
            html += `        <div class="control__indicator"></div>`;
            html += `    </label>`;
            html += `    <div class="LayerLegendEntryDetails">`;
            html += `        <input class="LayerLegendEntrySlider" type="range" min="0" max="1" step="0.05" value="${layer.opacity}" data-layer="${layer.id}" onChange="setOpacity(this.getAttribute('data-layer'), parseFloat(this.value));" title="Slide to adjust layer transparency" />`;
            html += `    </div>`;
            html += `</div>`;
            $(html).appendTo($legendarea);

            // now toggle the layer and set its opacity
            setOpacity(layer.id, parseFloat(layer.opacity));
            toggleLayer(layer.id, layer.on);
        });
    });
}


////////////////////////////////////////////////////////////////////////////////////////////////////////////
// GLOBAL FUNCTIONS


// show or hide the Sidebar
window.sidebarToggle = (showit)  => {
    // if showit isn't given, then toggle
    if (showit === undefined) showit = ! $('#Sidebar').is(':visible');

    // note the use of a 'left' to make a cool animation, as opposed to simple show/hide
    if (showit) {
        $('#Sidebar').css({ left: 0 });
        $('#SidebarHamburger').hide();
    }
    else {
        $('#Sidebar').css({ left: '-' + SIDEBARWIDTH + 'px' });
        $('#SidebarHamburger').show();
    }
};

// search MAP_LAYERS for the specified layerid
window.getLayerById = (layerid) => {
    var foundlayer;
    MAP_LAYERS.forEach((section) => {
        section.layers.forEach((layer) => {
            if (layer.id == layerid) foundlayer = layer;
        });
    });
    return foundlayer;
};

// is the specified map layer currently on the map?
window.isLayerOnMap = (layerid) => {
    var layer = getLayerById(layerid);
    if (! layer) throw "isLayerOnMap() specified layer does not exist: " + layerid;

    return MAP.hasLayer(layer.maplayer);
};

// toggle a map layer on or off
window.toggleLayer = (layerid, showit) => {
    var layer = getLayerById(layerid);
    if (! layer) throw "toggleLayer() specified layer does not exist: " + layerid;

    // if showit is unspecified, then find out and toggle it
    if (showit == undefined) showit = ! isLayerOnMap(layerid);

    // add/remove the map layer but be careful not to add/remove it a second time
    var already = isLayerOnMap(layerid);
    if (showit && ! already) MAP.addLayer(layer.maplayer);
    else if (already && ! showit) MAP.removeLayer(layer.maplayer);

    // toggle the LayerLegendEntryDetails (opacity slider, attributions, ...)
    var $deets = $('#Sidebar div.SidebarLayers div.LayerLegendEntry[data-layer="' + layerid + '"] div.LayerLegendEntryDetails');
    if (showit) {
        $deets.show();
    }
    else {
        $deets.hide();
    }
};

// set a map layer's opacity
window.setOpacity = (layerid, opacity) => {
    var layer = getLayerById(layerid);
    if (! layer) throw "setOpacity() specified layer does not exist: " + layerid;

    // set opacity for L.TileLayer and L.GeoJSON layers
    // try to provide this consistent API to two very different layer behaviors
    if (layer.maplayer.ajaxParams) {
        // apply the new style to the layer (only works if already visible) and as a on-load event (should it still be loading)
        const newstyle = {
            opacity: opacity,
            fillOpacity: opacity * 0.8,
        };

        layer.maplayer.on('data:loaded', function () {
            layer.maplayer.setStyle(newstyle);
        });
        layer.maplayer.setStyle(newstyle);
    }
    else {
        // must be a TileLayer
        layer.maplayer.setOpacity(opacity);
    }
};

window.selectBasemap = function (bmid) {
    BASEMAPS.forEach((layer) => {
        if (layer.id == bmid) {
            MAP.addLayer(layer.maplayer);
        }
        else {
            MAP.removeLayer(layer.maplayer);
        }
    });
};

// a little hack to define whether we should "act mobile" in ways that can only be known at runtime
window.isMobile = () => {
    return $(window).width() <= 768;
};



// WEBPACK FOOTER //
// ./index.js6